interface IConstants {
    VERSION: string;
}
const VERSION = `v${process.env.REACT_APP_VERSION}`;
export default { VERSION };
